import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorPageComponent} from "./error-page/error-page.component";
import {CardDetailComponent} from "./card-detail/card-detail.component";
import {TermsConditionsComponent} from "./terms-conditions/terms-conditions.component";
import {HomeComponent} from "./home/home.component";
import {PagesRoutingModule} from "./pages-routing.module";
import {
	NgbAccordionModule,
	NgbNavModule
} from "@ng-bootstrap/ng-bootstrap";
import {SharedModule} from "../shared/shared.module";


@NgModule({
	declarations: [
		HomeComponent,
		CardDetailComponent,
		TermsConditionsComponent,
		ErrorPageComponent
	],
	imports: [
		CommonModule,
		PagesRoutingModule,
		NgbNavModule,
		NgbAccordionModule,
		SharedModule,
	]
})
export class PagesModule {
}
